<script>

export default {
  name: "App",

  data() {
    return {
      selectedNewsCategories: [],
      selectedNewsYears: ''
    };
  },

  created: function () {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const paramCategories = urlParams.getAll('categories[]');
    const paramYear = urlParams.get('year');
    if (paramCategories) {
      this.selectedNewsCategories = paramCategories;
    }
    if (paramYear) {
      this.selectedNewsYear = paramYear;
    }
  },

  methods: {
    toggleNewsCategory: function (category) {
      const selectedCategoryIndex = this.selectedNewsCategories.indexOf(category);
      if (selectedCategoryIndex > -1) {
        this.selectedNewsCategories.splice(selectedCategoryIndex, 1);
      } else {
        this.selectedNewsCategories.push(category);
      }
    },

    showNewsWithCategories: function (e) {
      let url = new URL(e.target.href);
      url.searchParams.set('categories', this.selectedNewsCategories.join(','));
      if (url.searchParams.has('year')) {
        url.searchParams.set('year', url.searchParams.get('year'));
      }
      window.location = url.href;
    }
  }
};
</script>